import { CrudPage } from "../components/CrudPage";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";
import { formatRupiah, formatTanggal } from "../lib/format";

const empty = { nama_item: "", harga: 0, satuan: "pcs", keterangan: "" };

const columns = [
    { key: "nama_item", header: "Nama Item", className: "font-medium text-slate-900" },
    { key: "harga", header: "Harga", render: (r) => <span className="num-tabular">{formatRupiah(r.harga)}</span> },
    { key: "satuan", header: "Satuan", render: (r) => <span className="text-xs uppercase text-slate-600">{r.satuan}</span> },
    { key: "keterangan", header: "Keterangan", className: "text-slate-500 max-w-xs truncate" },
    { key: "created_at", header: "Dibuat", render: (r) => formatTanggal(r.created_at), className: "text-slate-500" },
];

const renderForm = (form, setForm) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
            <Label>Nama Item <span className="text-rose-600">*</span></Label>
            <Input
                data-testid="peralatan-form-nama"
                value={form.nama_item}
                onChange={(e) => setForm({ ...form, nama_item: e.target.value })}
                className="mt-1.5 rounded-xl"
                placeholder="Contoh: Benang Hitam"
            />
        </div>
        <div>
            <Label>Harga (Rp)</Label>
            <Input
                type="text"
                inputMode="decimal"
                data-testid="peralatan-form-harga"
                value={form.harga}
                onChange={(e) => setForm({ ...form, harga: e.target.value })}
                className="mt-1.5 rounded-xl"
                placeholder="5000"
            />
        </div>
        <div>
            <Label>Satuan</Label>
            <Select value={form.satuan} onValueChange={(v) => setForm({ ...form, satuan: v })}>
                <SelectTrigger data-testid="peralatan-form-satuan" className="mt-1.5 rounded-xl"><SelectValue /></SelectTrigger>
                <SelectContent>
                    <SelectItem value="pcs">Pcs</SelectItem>
                    <SelectItem value="lusin">Lusin</SelectItem>
                    <SelectItem value="roll">Roll</SelectItem>
                    <SelectItem value="pack">Pack</SelectItem>
                    <SelectItem value="cones">Cones</SelectItem>
                </SelectContent>
            </Select>
        </div>
        <div className="sm:col-span-2">
            <Label>Keterangan</Label>
            <Textarea
                value={form.keterangan}
                onChange={(e) => setForm({ ...form, keterangan: e.target.value })}
                className="mt-1.5 rounded-xl"
                rows={2}
            />
        </div>
    </div>
);

const validate = (f) => {
    if (!f.nama_item?.trim()) return "Nama item wajib diisi";
    return null;
};

export default function PeralatanPage() {
    return (
        <CrudPage
            title="Master Peralatan Pembantu"
            subtitle="Bahan pembantu produksi seperti benang, kancing, resleting"
            endpoint="/master/peralatan"
            entityLabel="Peralatan"
            columns={columns}
            emptyForm={empty}
            renderForm={renderForm}
            validate={validate}
            testidBase="peralatan"
        />
    );
}
